import { Component, HostListener, Input, OnInit, Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
})
export class CardComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  bigZindex: boolean = false;

  @Input()
  cssClass: string;

  @Input()
  desktopHeaderButtonIcon: string;

  @Input()
  desktopHeaderButtonUrl: string;

  @Input()
  hideHeaderBreakpoint: number = 992;

  @Output()
  emitAsideButtonIcon: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  paddingZeroBreakpoint: number;

  // Width booleans
  hideHeader: boolean;
  paddingZero: boolean;

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.setWidthBooleans();
  }

  ngOnInit() {
    this.setWidthBooleans();
  }

  onButtonClicked() {
    this.emitAsideButtonIcon.emit();
  }

  calcMobileView(): boolean {
    return this.hideHeaderBreakpoint > window.innerWidth;
  }
  setWidthBooleans() {
    this.hideHeader = this.hideHeaderBreakpoint > window.innerWidth;
    this.paddingZero = this.paddingZeroBreakpoint >= window.innerWidth;
  }
}
